<template>
  <i class="fa fa-fw fa-whatsapp"></i>
</template>

<script>
export default {
  name: 'WhatsappWeb',
};
</script>

<style scoped>
.fa-whatsapp {
  color: #0fa251;
}
</style>



// WEBPACK FOOTER //
// WhatsappWebIcon.vue?31713d15